import React, { useEffect, useState } from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import HelpTooltip from "@/shared/components/help-tooltip";
import { toTitle } from "@/utils/case";
import { Company } from "@/features/types";
import AppCompanySelect from "@/features/line-sheet-sets/app-company-select";
import SVG from "react-inlinesvg";
import ChipList from "@/features/order-sheet-sets/ChipList";
import { BestSellingSectionQuery } from "@/features/dashboard/features/best-selling-section/hooks/useBsQuery";
import { NavigateOptions } from "react-router";
import AppCheckBox from "@/features/line-sheet-sets/app-checkbox";

interface Props {
  query: BestSellingSectionQuery;
  setQuery: (
    updater: (prev: BestSellingSectionQuery) => BestSellingSectionQuery,
    navigateOpts?: NavigateOptions | undefined
  ) => void;
  clear: () => void;
  showOrderable: boolean;
}

export default function BestSellingHeader({ query, setQuery, clear, showOrderable }: Props) {
  const { t, tSentence, tTitle } = useI18nHelper();
  const [queryCount, setQueryCount] = useState(0);

  useEffect(() => {
    const initialCount = query.brandIdsBs?.length || 0;
    setQueryCount(initialCount);
  }
  , [query.brandIdsBs]);

  return (
    <Flex flexDirection={"column"} width={"100%"} gap={"12px"} mr={"4px"}>
      <Flex justifyContent={"space-between"}>
        <Flex gap={"2px"} alignItems={"center"}>
          <Text textStyle={"body-lg-bold"}>
            {t("best_selling_section_title")}
          </Text>
          <HelpTooltip
            text={tSentence("best_selling_section_title_tooltip")}
            iconsSize={20}
          />
        </Flex>
        {
          showOrderable &&
          <Flex gap={"16px"} alignItems={"center"}>
            <Flex flexDirection={"column"} gap={"8px"}>
              <AppCheckBox
                name={t("common\:show_orderable")}
                isChecked={query.isOrderable}
                onChange={(isChecked) => {
                  setQuery((prev) => ({
                    ...prev,
                    isOrderable: isChecked
                  }));
                }}
              />
            </Flex>
          </Flex>
        }
      </Flex>
      {queryCount > 0 && (
        <Flex gap={"12px"}>
          <Flex
            gap={"4px"}
            alignItems={"center"}
            minWidth={"56px"}
            onClick={() => {
                clear();
                setQueryCount(0);
            }}
            _hover={
              { cursor: "pointer", color: "#1272EF" }
            }>
            <SVG
              src={"/icons-v1_1/arrow-rotate.svg"}
              width={"16px"}
              height={"16px"}
              color={"#8F8F8C"}
            />
            <Text textStyle="body-sm-bold" color={"#444444"}>
              {t("clear_all")}
            </Text>
          </Flex>
          <Text key={"Divider"} color={"#D4D4D1"}>
            |
          </Text>
          <ChipList key={"ChipList"} query={query} setQuery={setQuery} />
        </Flex>
      )}
    </Flex>
  );
}
